module.exports = __webpack_public_path__ + "static/media/task-special.3061746c.svg";